import * as React from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import PrioritySelectItem from "components/priority/PrioritySelectItem";
import { Filter } from "constants/filters";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";

import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: { priority: string[] };
  onChange(filterUpdate: { value: { priority: string[] } | null; name: string }): void;
}

const items = Object.values(TicketPriority)
  .filter(value => typeof value === "number")
  .map(key => ({
    key: key.toString(),
    name: key.toString(),
    customElement: {
      selectedItemBody: <div>{TICKET_PRIORITY_LABEL_MAP[key as TicketPriority]}</div>,
      listItemBody: <PrioritySelectItem priority={key as TicketPriority} />,
    },
  }))
  .reverse();

const PriorityFilter: React.FC<IProps> = ({ filterValues, onChange }) => {
  const handleChange = (selectedItems: IPickerListItem[] | null): void => {
    const isEmpty = !selectedItems || selectedItems.length === 0;

    onChange({
      name: Filter.Priority,
      value: isEmpty ? null : { priority: selectedItems?.map(item => item.key) ?? [] },
    });
  };

  const selectedPriorities = items
    .filter(priority => filterValues?.priority?.includes(priority.key))
    .map(priority => ({
      key: priority.key,
      name: TICKET_PRIORITY_LABEL_MAP[priority.key as unknown as TicketPriority],
    }));

  return (
    <Picker
      id="priority-filter"
      onSelect={handleChange}
      type="multi"
      hideClearButton
      options={items}
      selected={selectedPriorities}
      placeholder="Select"
      searchDisabled
      openedOnInit
    />
  );
};

export default withFilterBase(PriorityFilter);
